import type {
  SupplierRelationshipDiscountUpdateRequestType,
  SupplierRelationshipDiscountUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSupplierRelationshipDiscountUpdate = (
  supplierRelationshipDiscountId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: SupplierRelationshipDiscountUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `supplier-relationship-discounts/${supplierRelationshipDiscountId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as SupplierRelationshipDiscountUpdateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SupplierRelationshipDiscounts,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Products],
      });
    },
  });
};
